var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box is-centered wrapper-document-details" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _vm.voucherType === "T"
          ? _c(
              "h1",
              {
                staticClass:
                  "title is-centered is-4 has-text-primary title-transfers-details"
              },
              [_vm._v("\n      Detalles de Traslado\n    ")]
            )
          : _vm.voucherType === "E"
          ? _c(
              "h1",
              {
                staticClass:
                  "title is-centered is-4 has-text-primary title-invoice-details"
              },
              [_vm._v("\n      Detalles de Nota de crédito\n    ")]
            )
          : _c(
              "h1",
              {
                staticClass:
                  "title is-centered is-4 has-text-primary title-invoice-details"
              },
              [_vm._v("\n      Detalles de Factura\n    ")]
            ),
        _c("div", { staticClass: "field is-centered" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.advanced,
                expression: "advanced"
              }
            ],
            staticClass: "is-checkradio",
            class: { "is-success": _vm.advanced },
            attrs: { id: "advanced", name: "advanced", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.advanced)
                ? _vm._i(_vm.advanced, null) > -1
                : _vm.advanced
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.advanced,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.advanced = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.advanced = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.advanced = $$c
                  }
                },
                _vm.onChangeAdvanced
              ]
            }
          }),
          _c(
            "label",
            { staticClass: "is-centered", attrs: { for: "advanced" } },
            [_vm._v("\n        Opciones Avanzadas\n      ")]
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "columns is-multiline" },
        [
          !_vm.isTradeTransfer
            ? _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppSelectSearch", {
                    attrs: {
                      id: "voucherPaymentType",
                      name: "voucherPaymentType",
                      label: "Forma de pago",
                      placeholder: "Selecciona la forma de pago",
                      options: _vm.paymentTypeCatalog,
                      value: _vm.paymentTypeSelectedValue,
                      disabled: _vm.isLoading || _vm.disabled
                    },
                    on: { input: _vm.onChange, change: _vm.onChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-4": _vm.inline }
            },
            [
              _c("AppSelectSearch", {
                attrs: {
                  id: "receiverCfdiUsage",
                  name: "receiverCfdiUsage",
                  label: "Uso CFDI",
                  placeholder: "Uso del CFDI",
                  value: _vm.cfdiUseSelected,
                  options: _vm.cfdiUseCatalog,
                  disabled: _vm.disabled,
                  "is-loading": _vm.isLoading,
                  required: true
                },
                on: { input: _vm.onChange, change: _vm.onChange }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advanced,
                  expression: "advanced"
                }
              ],
              staticClass: "column",
              class: { "is-12": !_vm.inline, "is-4": _vm.inline }
            },
            [
              _c("AppInputField", {
                attrs: {
                  id: "voucherDate",
                  name: "voucherDate",
                  label: "Fecha y hora de expedición*:",
                  type: "dateTime-local",
                  value: _vm.voucherDateToInput,
                  min: _vm.minDateTime,
                  max: _vm.maxDateTime,
                  "left-icon": "calendar",
                  disabled: ""
                }
              })
            ],
            1
          ),
          !_vm.isTradeTransfer
            ? _c(
                "div",
                {
                  staticClass: "column",
                  class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                },
                [
                  _c("AppSelectField", {
                    attrs: {
                      id: "voucherPaymentMethod",
                      name: "voucherPaymentMethod",
                      label: "Metodo de pago:",
                      options: _vm.paymentMethodCatalog,
                      value: _vm.voucherPaymentMethod,
                      disabled: _vm.isLoading || _vm.disabled
                    },
                    on: { input: _vm.onChange, change: _vm.onChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.advanced
            ? [
                false
                  ? _c(
                      "div",
                      {
                        staticClass: "column",
                        class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                      },
                      [
                        _c("AppInputField", {
                          attrs: {
                            id: "voucherExpeditionPlace",
                            name: "voucherExpeditionPlace",
                            label: "Código postal*:",
                            placeholder: "02719",
                            value: _vm.voucherExpeditionPlace,
                            disabled: _vm.isLoading || _vm.disabled,
                            required: true
                          },
                          on: { input: _vm.onChange, change: _vm.onChange }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppSelectSearch", {
                      attrs: {
                        id: "voucherCurrency",
                        name: "voucherCurrency",
                        label: "Moneda*:",
                        placeholder: "Selecciona una moneda",
                        options: _vm.currencyCatalog,
                        value: _vm.currencySelectedValue,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: {
                        input: _vm.onChangeCurrency,
                        change: _vm.onChangeCurrency
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.otherCurrency || _vm.voucherCurrency !== "MXN",
                        expression: "otherCurrency || voucherCurrency !== 'MXN'"
                      }
                    ],
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherExchangeRate",
                        name: "voucherExchangeRate",
                        label: "Tipo de cambio:",
                        placeholder: "0.00",
                        value: _vm.voucherExchangeRate,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _vm.voucherPaymentMethod === "PPD"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "column",
                          class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                        },
                        [
                          _c(
                            "BField",
                            {
                              attrs: {
                                label: "Fecha de vencimiento",
                                "label-for": "expirationDate"
                              }
                            },
                            [
                              _c(
                                "BDatepicker",
                                _vm._b(
                                  {
                                    attrs: {
                                      id: "expirationDate",
                                      value: _vm.expirationDate,
                                      "date-parser": _vm.dateParser,
                                      disabled: _vm.isLoading || _vm.disabled,
                                      icon: "calendar-today"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onChangeExpiration(
                                          "operation.expirationDate",
                                          $event
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.onChangeExpiration(
                                          "operation.expirationDate",
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  "BDatepicker",
                                  _vm.calendarProps,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    class: { "is-12": !_vm.inline, "is-4": _vm.inline }
                  },
                  [
                    _c("AppSelectField", {
                      attrs: {
                        id: "voucherType",
                        name: "voucherType",
                        label: "Tipo de comprobante:",
                        options: _vm.voucherTypeCatalog,
                        value: _vm.voucherType,
                        disabled: ""
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column is-6-mobile is-3" },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherSeries",
                        name: "voucherSeries",
                        label: "Serie:",
                        pattern: _vm.pattern,
                        value: _vm.voucherSeries,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column is-6-mobile is-4" },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherConsecutive",
                        name: "voucherConsecutive",
                        label: "Folio:",
                        type: "number",
                        min: "1",
                        value: _vm.voucherConsecutive,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: { input: _vm.onChange, change: _vm.onChange }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }